import React from 'react';
import ReactDOM from 'react-dom';
import App from '../src/components/App'
// import imojidata from '../src/emojination';

ReactDOM.render(<App />, document.getElementById('root'));

